import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../home/components/Footer';

export default function Company() {
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);

    // Load Calendly widget script
    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-white border-b border-[#e8e6e3] sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
          <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }} className="cursor-pointer z-50">
            <img 
              src="https://static.readdy.ai/image/05cd76bb9b80c0f39a77a9e694effa95/826c552476badc913a23e7605116bff7.png" 
              alt="MeVER Chair ロゴ" 
              title="MeVER Chair"
              className="h-7 sm:h-8 w-auto"
            />
          </a>

          {/* Desktop Menu */}
          <div className="hidden lg:flex items-center space-x-8">
            <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }} className="text-sm font-medium text-[#1a2332] hover:text-[#4a5568] transition-colors cursor-pointer whitespace-nowrap">
              トップページ
            </a>
            <span className="text-sm font-bold text-[#1a2332] border-b-2 border-[#1a2332] whitespace-nowrap">
              会社概要
            </span>
          </div>

          {/* Mobile Hamburger Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden z-50 w-10 h-10 flex items-center justify-center cursor-pointer"
            aria-label="メニュー"
          >
            {isMobileMenuOpen ? (
              <i className="ri-close-line text-2xl text-[#1a1a2e]"></i>
            ) : (
              <i className="ri-menu-line text-2xl text-[#1a1a2e]"></i>
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        <div className={`lg:hidden fixed inset-0 bg-white z-40 transition-transform duration-300 ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`}>
          <div className="flex flex-col pt-20 px-6 space-y-6">
            <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); setIsMobileMenuOpen(false); }} className="text-base font-medium text-[#1a1a2e] hover:text-[#8E7CC3] transition-colors cursor-pointer py-3 border-b border-[#e8e6e3]">
              トップページ
            </a>
            <span className="text-base font-bold text-[#1a1a2e] py-3 border-b border-[#e8e6e3]">
              会社概要
            </span>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#f5f3ef] to-[#e8e6e3] py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-[#1a1a2e] mb-4">会社概要</h1>
            <p className="text-lg text-[#4a4a4a]">Company Profile</p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-6 py-16">
        {/* Company Info Table */}
        <div className="bg-white rounded-2xl border border-[#e8e6e3] overflow-hidden shadow-sm mb-16">
          <table className="w-full">
            <tbody>
              <tr className="border-b border-[#e8e6e3]">
                <th className="text-left py-5 px-6 md:px-8 bg-[#f8f8f8] text-[#1a1a2e] font-semibold text-base w-1/4 md:w-1/5">会社名</th>
                <td className="py-5 px-6 md:px-8 text-[#4a4a4a] text-base">ビットムーブスジャパン株式会社</td>
              </tr>
              <tr className="border-b border-[#e8e6e3]">
                <th className="text-left py-5 px-6 md:px-8 bg-[#f8f8f8] text-[#1a1a2e] font-semibold text-base">英文社名</th>
                <td className="py-5 px-6 md:px-8 text-[#4a4a4a] text-base">BITMOVES Japan Inc.</td>
              </tr>
              <tr className="border-b border-[#e8e6e3]">
                <th className="text-left py-5 px-6 md:px-8 bg-[#f8f8f8] text-[#1a1a2e] font-semibold text-base">所在地</th>
                <td className="py-5 px-6 md:px-8 text-[#4a4a4a] text-base">
                  〒100-6213<br />
                  東京都千代田区丸の内1-11-1<br />
                  パシフィックセンチュリープレイス丸の内13F
                </td>
              </tr>
              <tr className="border-b border-[#e8e6e3]">
                <th className="text-left py-5 px-6 md:px-8 bg-[#f8f8f8] text-[#1a1a2e] font-semibold text-base">事業内容</th>
                <td className="py-5 px-6 md:px-8 text-[#4a4a4a] text-base">
                  <ul className="space-y-2">
                    <li className="flex items-start">
                      <span className="w-1.5 h-1.5 bg-[#8E7CC3] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                      <span>空間ソリューション事業</span>
                    </li>
                    <li className="flex items-start">
                      <span className="w-1.5 h-1.5 bg-[#8E7CC3] rounded-full mt-2 mr-3 flex-shrink-0"></span>
                      <span>オフィス家具/ガジェットの企画・開発・販売</span>
                    </li>
                  </ul>
                </td>
              </tr>
              <tr className="border-b border-[#e8e6e3]">
                <th className="text-left py-5 px-6 md:px-8 bg-[#f8f8f8] text-[#1a1a2e] font-semibold text-base">主要取引先</th>
                <td className="py-5 px-6 md:px-8 text-[#4a4a4a] text-base">
                  国内大手IT企業、外資系コンサルティングファーム、<br />
                  スタートアップ企業、在日米軍基地
                </td>
              </tr>
              <tr>
                <th className="text-left py-5 px-6 md:px-8 bg-[#f8f8f8] text-[#1a1a2e] font-semibold text-base">お問い合わせ</th>
                <td className="py-5 px-6 md:px-8 text-[#4a4a4a] text-base">
                  <a href="mailto:info@mever.design" className="text-[#8E7CC3] hover:underline cursor-pointer">info@mever.design</a>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Calendly Booking Section */}
        <div className="bg-white rounded-2xl border border-[#e8e6e3] overflow-hidden shadow-sm p-8">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-[#1a1a2e] mb-3">オンライン相談予約</h2>
            <p className="text-base text-[#4a4a4a]">お気軽にご相談ください。ご都合の良い日時をお選びいただけます。</p>
          </div>
          
          <div 
            className="calendly-inline-widget" 
            data-url="https://calendly.com/bitmoves_zenko/calendly" 
            style={{ minWidth: '320px', height: '700px' }}
          ></div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
